import { getBoneBoundary, offsetPolygon } from "@project-rouge/rg-three";
function getWingPoly({ building, bone, level, skipCornerCores = false }) {
  const boneBoundary = getBoneBoundary({
    building,
    bone,
    level,
    includeCornerCores: skipCornerCores ? "never" : "always"
  });
  const boundary = offsetPolygon(boneBoundary, 0.01);
  return boundary.map((b) => [b[0], b[2]]);
}
export {
  getWingPoly
};
//# sourceMappingURL=index175.js.map
